import Vue from 'vue'
import vuetify from './plugins/vuetify'
import Member from './Member.vue'

Vue.config.productionTip = false


new Vue({
   vuetify,
   render: h => h(Member)
}).$mount('#member')

